/**
 * RAG-based CTI Knowledge Query API.
 */

import apiClient from './client';
import type { QueryRequest, QueryResponse } from './types';

export async function submitQuery(request: QueryRequest): Promise<QueryResponse> {
  const response = await apiClient.post('/cti/query', request);
  return response.data;
}
